<template>
  <div class="home" v-title data-title="营销中心">
    <!-- <header>
      <p class="home-title">
        首页
      </p>
    </header> -->
    <section>
      <!-- <h1>{{ $store.state.name }}</h1> -->
      <!-- 轮播图 -->
      <div class="swipe">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item @click="skip_card_ecommend(item.url)" v-for="(item,index) in swipe_list" :key="index">
            <img :src=item.image alt="">
          </van-swipe-item>
          <!-- <van-swipe-item>
            <img src="../../assets/images/home-img/card.png" alt="">
          </van-swipe-item> -->
        </van-swipe>
      </div>
      <homeMemu></homeMemu>
      <van-tabs v-model="active" 
        line-height="0px"
        title-inactive-color="#0C0C0C"
        title-active-color="#FFA009"
        >
        <van-tab title="会员推荐">
          <membersRecommended :member_card_List="member_card_List"></membersRecommended>
        </van-tab>
        <van-tab title="精选推荐">
          <selectionRecommended :activity_List="activity_List"></selectionRecommended>
        </van-tab>
      </van-tabs>
    </section>
    <footer>
      <tabar></tabar>
    </footer>
  </div>
</template>

<script>
import tabar from '../../components/tabar/tabar'
import homeMemu from '../../components/home/home-memu'
import membersRecommended from '../../components/home/members-recommended'
import selectionRecommended from '../../components/home/selection-recommended'

import Vue from 'vue';

import { Swipe, SwipeItem, Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  name: 'home',
  data(){
    return{
      activity_List: [], //精品推荐
      member_card_List: [], //精品推荐
      tag1: '', // 标签
      tag2: '', // 标签
      swipe_list: [], // 轮播图
      userId:'',
      present_url:'',
      active: 0,
    }
  },
  created(){
    // 登录 / 分享登录
    let uid = JSON.parse(localStorage.getItem("uid"));
    if(!uid){
      let wxcode = this.$route.query.code
      // 获取code
      if(!wxcode){
        //appid 可以从后端传过来 也可以写死 
        let APPID = this.domain.APPID
        // 跳转回调redirect_uri 可以从后端传过来 也可以写死 但是url必须是公网可访问的
        let REDIRECT_URI = encodeURIComponent(this.domain.local_url)
        // 返回类型
        let code = 'code';
        // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且， 即使在未关注的情况下，只要用户授权，也能获取其信息 ）
        let SCOPE = 'snsapi_userinfo';
        let STATE = '123';//随便写
        let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + APPID + '&redirect_uri=' + REDIRECT_URI + '&response_type=' + code + '&scope=' + SCOPE + '&state=' + STATE + '#wechat_redirect';
        window.location.href = url;
        // console.log(url)
        // console.log(encodeURIComponent(this.domain.local_url))
      }else{
        // 传code
        this.$axios.get(this.domain.url+"/api/user/public/login",{
          params:{
            pid : uid,
            code : wxcode,
            url : this.domain.local_url
          },
        }).then((res) => {
          // console.log(res.data.data.uid)
          window.localStorage.setItem('uid',JSON.stringify(res.data.data.uid));
        })
      }
    }else{
      this.$axios.get(this.domain.url+"/api/home/index/islogin").then((res) => {
        // console.log(res)
        if(res.data.code == 0){
          window.localStorage.removeItem('uid');
          this.$router.go(0)
        }
      })
    }
  },
  
  mounted(){
    // 判断登录
    this.present_url = this.$route.path
    this.$axios.get(this.domain.url+"/api/home/index/islogin").then((res) =>{
      // 大坑
    })
    // 轮播图
    this.$axios.get(this.domain.url+"/api/home/slides/1").then((res) => {
      // console.log(res.data.data)
      this.swipe_list = res.data.data[0].items
    })
    // 精品推荐
    this.$axios.get(this.domain.url+"/api/goods/index/recommendgoods").then((res) => {
      // console.log(res.data.data)
      this.activity_List = res.data.data
    })
    this.$axios.get(this.domain.url+"/api/goods/index/cardlist").then((res) => {
      // console.log(res.data.data)
      this.member_card_List = res.data.data
    })
  },
  methods:{
    // 标签样式
    tagStyle(index){
      return "person_" + index
    },
    // 轮播图活动详情
    skip_card_ecommend(url){
      // console.log(url)
      window.location.href = url
    },
    // 推荐详情
    activityDetailsBtn(id){
      let usrId = JSON.parse(localStorage.getItem("uid"));

      // console.log(id)
      this.$router.push({
        path:'/activity-detail',
        query:{
          id : id,
          // pid : usrId
        }
      })
    },
    //会员卡系列
    cardsDetailsBtn(id){
      let usrId = JSON.parse(localStorage.getItem("uid"));

      // console.log(id)
      this.$router.push({
        path:'/card-ecommend',
        query:{
          id : id
        }
      })
    }
  },
  components: {
    tabar,
    homeMemu,
    membersRecommended,
    selectionRecommended
  }
}
</script>
<style lang="less" scoped>
  .home{
    width: 7.5rem;
    // height: 100%;
    display: flex;
    flex-direction: column;
    // overflow: hidden;
    background: #FAFAFA;
    header{
      width: 100%;
      height: .88rem;
      line-height: .88rem;
      text-align: center;
      font-family: PingFangSC-Regular;
      color: #FFFFFF;
      font-size: .36rem;
      background: linear-gradient(310deg,#232323 0%,#4A4A4A 57%,#333333 100%);
    }
    section{
      width: 100%;
      // height: 100%;
      // display: flex;
      // flex-direction: column;
      // overflow: scroll;
      // flex: 1;
      // overflow: hidden;
      margin-bottom: .98rem;
      // 轮播图
      .swipe{
        width: 7.1rem;
        height: 3.4rem;
        margin: 0 auto;
        margin-top: .2rem;
        .my-swipe .van-swipe-item {
          width: 100%;
          height: 100%;
          img{
            width: 100%;
            height: 3rem;
          }
          
        }
      }
      .van-tabs{
        margin-top: .18rem;
      }
      /deep/.van-tabs__nav{
        width: 7.16rem;
        height: .9rem;
        margin: 0 auto;
      }
    }
    footer{
      position: fixed;
      bottom: 0;
    }
  }
</style>
